import { useMemo } from 'react';
import { IFieldDefinition, customSWRConfig } from '../../model/types';
import { refactorFieldOptions } from './useFieldDefinitionListFromAgentForm';
import useTicketFieldDefinitionList, { getUIFriendlyTicketFieldDefinitionList } from './useTicketFieldDefinitionList';

export default function useFieldDefinitionByKey(key: string, config: customSWRConfig = {}) {
    const { data } = useTicketFieldDefinitionList(true, config);

    const fieldDefinition = useMemo(
        () => refactorFieldOptions<IFieldDefinition>((getUIFriendlyTicketFieldDefinitionList(data).listMap || {})[key]),
        [data, key]
    );

    return fieldDefinition;
}
